export default {
  "menu.welcome": "欢迎",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.dashboard": "数据看板",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "表单页",
  "menu.form.basic-form": "基础表单",
  "menu.form.step-form": "分步表单",
  "menu.form.step-form.info": "分步表单（填写转账信息）",
  "menu.form.step-form.confirm": "分步表单（确认转账信息）",
  "menu.form.step-form.result": "分步表单（完成）",
  "menu.form.advanced-form": "高级表单",
  "menu.list": "列表页",
  "menu.list.table-list": "查询表格",
  "menu.list.basic-list": "标准列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜索列表",
  "menu.list.search-list.articles": "搜索列表（文章）",
  "menu.list.search-list.projects": "搜索列表（项目）",
  "menu.list.search-list.applications": "搜索列表（应用）",
  "menu.profile": "详情页",
  "menu.profile.basic": "基础详情页",
  "menu.profile.advanced": "高级详情页",
  "menu.result": "结果页",
  "menu.result.success": "成功页",
  "menu.result.fail": "失败页",
  "menu.exception": "异常页",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "触发错误",
  "menu.account": "个人页",
  "menu.account.center": "个人中心",
  "menu.account.settings": "个人设置",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",
  "menu.permission": "用户权限",
  "menu.permission.adminList": "管理员列表",
  "menu.permission.inspectorList": "巡查员列表",
  "menu.userManagement": "用户管理",
  "menu.userManagement.userList": "用户列表",
  "menu.userManagement.userList.userDetail": "用户详情",
  "menu.userManagement.userDetail": "用户详情",
  "menu.userManagement.answerUnblocked": "答题解封",
  "menu.userManagement.answerUnblocked.answerRecord": "答题记录",
  "menu.userManagement.blackList": "手机号黑名单",
  "menu.content": "内容",
  "menu.content.activity": "活动",
  "menu.content.channel": "频道",
  "menu.content.channel.config": "频道配置",
  "menu.content.channel.list": "新闻列表",
  "menu.content.channel.source": "来源列表",
  "menu.content.common-software": "常用软件",
  "menu.content.local-offers": "本地特惠",
  "menu.content.milestone": "里程碑",
  "menu.content.public-services": "民生服务",
  "menu.content.businessCase": "商务案例",
  "menu.content.communityTheme": "社区主题",
  "menu.content.communityReply": "社区回复",
  "menu.review": "审核",
  "menu.review.businessExemption": "商务免审名单",
  "menu.review.thread": "帖子",
  "menu.review.thread.topic": "主题",
  "menu.review.thread.reply": "回复",
  "menu.review.users": "用户",
  "menu.review.users.avatar": "头像",
  "menu.review.users.nickName": "昵称",
  "menu.review.users.signature": "签名",
  "menu.review.AIReview": "AI审核结果",
  "menu.review.AIReview.topic": "主题",
  "menu.review.AIReview.reply": "回复",
  "menu.review.AIReview.avatar": "头像",
  "menu.review.AIReview.nickName": "昵称",
  "menu.review.AIReview.signature": "签名",
  "menu.review.riskReview": "风险复查",
  "menu.review.riskReview.topic": "主题",
  "menu.review.riskReview.reply": "回复",
  "menu.review.reviewReport": "复审",
  "menu.review.reviewReport.report": "举报",
  "menu.review.reviewReport.appeal": "申诉",
  "menu.review.keywordsThesaurus": "关键词库管理",
  "menu.operation": "运营",
  "menu.operation.payActivity": "付费活动",
  "menu.operation.buriedPoint": "H5埋点数据统计",
  "menu.operation.recommend": "推荐帖",
  "menu.operation.groupSending": "群发站内信",
};
